<template>
  <div
    class="file-upload-widget"
    @dragenter.prevent="highlight"
    @dragover.prevent="highlight"
    @dragleave.prevent="unhighlight"
    @drop.prevent="handleDrop"
    :class="{ highlight: isHighlighted }"
  >
    <input type="file" accept=".csv" ref="fileInput" hidden @change="handleFiles" />
    <div class="drop-area">
      <img :src="uploadImg" class="upload-icon" />
      <p class="drop-text" v-if="isHighlighted">
        Release file to begin processing
      </p>
      <p class="drop-text" v-else>
        <span class="bold-text">Drop your files here or </span>
        <span class="browse-link" @click="browseFiles"
          >click to browse</span
        >
      </p>
      <p class="sub-text">Supported format is .csv</p>
    </div>

		<md-snackbar
			md-position="center"
			:md-duration="6000"
			:md-active.sync="snackBar.show"
			md-persistent
		>
			<span>{{ snackBar.message }}</span>
		</md-snackbar>
  </div>
</template>

<script>
import UploadImg from '../assets/img/upload.png';
import Validator from '../utils/Validator';

export default {
  data() {
    return {
      isHighlighted: false,
      uploadImg: UploadImg,
      fileValidationConfig: {
        mimeList: ['text/csv', 'application/vnd.ms-excel'],
        extension: '.csv',
      },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    highlight() {
      this.isHighlighted = true;
    },
    unhighlight() {
      this.isHighlighted = false;
    },
    handleDrop(event) {
      event.preventDefault();
      const { files } = event.dataTransfer;
      this.handleFiles(files, true);
      this.unhighlight();
    },
    browseFiles() {
      this.$refs.fileInput.click();
    },
    handleFiles(event, isDropped = false) {
      const file = isDropped
        ? event[0]
        : event.target.files[0];

      if (!file) return;

      const { valid, message } = Validator.fileTypeIsValid(file, this.fileValidationConfig);

      if (!valid) {
        this.snackBar = {
          show: true,
          message,
        };
        return;
      }

      this.$emit('fileUploaded', file);
    },
  },
};

</script>

<style scoped>
.sub-text {
  font-family: 'Open Sans';
  font-size: 12px;
  color: #6d6d6d;
}

.bold-text {
  font-weight: 700;
}

.upload-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  margin-bottom: 8px;
}

.file-upload-widget {
  border: 2px solid #CBD5E1;
  border-radius: 12px;
  height: 180px;
  text-align: center;
  transition: border-color 0.3s;
  position: relative;
  z-index: 999999999999;
}

.drop-area {
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
}

.drop-text {
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  margin-bottom: 8px;
}

.drop-area .highlight {
  border-color: #007bff;
}

.browse-link {
  color: #8ca32b;
  cursor: pointer;
}
</style>
